import { render, staticRenderFns } from "./MapDefaultMarker.vue?vue&type=template&id=65b2659d"
import script from "./MapDefaultMarker.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapDefaultMarker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports